<template>
    <div>
        <Breadcrumb section-name="Income" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="addWithdraw"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue";
import dayjs from "dayjs";
export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: [],
            param: {
                keyword: '',
                limit: 10,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
                project_id: '',
                bank_id: '',
            },
            table: {
                total: {
                    colspan: 5,
                    amount: ''
                },
                columns: [
                    {type: 'text', key: 'date', label: 'Date', sortable: true},
                    {type: 'text', key: 'project_name', label: 'Project', photo: true, sortable: true},
                    {type: 'text', key: 'bank_name', label: 'Bank Name', photo: true, sortable: true},
                    {type: 'text', key: 'check_number', label: 'Check Number', sortable: true},
                    {type: 'text', key: 'Branch Name', label: 'Branch Name', sortable: true},
                    {type: 'text', key: 'amount', label: 'Amount', sortable: true},
                    {type: 'text', key: 'shareholder_name', label: 'Withdraw By', sortable: true},
                    {type: 'text', key: 'requisition_for', label: 'Requisition For', sortable: true}
                ],
                rows: [],
                row_actions: [
                    // {name: 'print', type: 'action', label: 'bx bx-printer', color: 'btn-primary', loading: false},
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.tableIconAction(data.row_action, data.row_data, data.row_index);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                dropdown: [
                    {
                        title: 'All Project',
                        data: [],
                        action: (event) => {
                            this.param.project_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Bank',
                        data: [],
                        action: (event) => {
                            this.param.bank_id = event.target.value
                            this.list()
                        }
                    },
                ],
                download: [

                ],
                noDataError: ' Please click "+ Add Bank Withdraw" to add a new withdraw',
            },
            id: []
        }
    },
    watch: {

    },
    methods: {
        addWithdraw() {
            this.$router.push({
                name: 'addBankWithdraw'
            });
        },
        fetchBank() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[0].data = res.data.data;
                }
            });
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Bank + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[1].data = res.data.data;
                }
            });
        },
        async tableIconAction (type, data, index = null) {
            this.id = this.structureReturnData(data)
            if (type === 'edit') {
                const url = this.$router.resolve({
                    name: 'editBankWithdraw',
                    params: { id: data.id }
                }).href
                window.open(url, '_blank')
            } else if (type === 'delete') {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'Delete Income',
                    message: 'Are you sure you want to delete this?',
                    okButton: 'Delete',
                })
                if (ok) {
                    this.delete()
                }
            } else if (type === 'print') {
                if (index != null) {
                    PrintService.print('/income/print/' + data.id);
                }
            }
        },

        list: function (page) {
            if (page === undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.BankWithdraw + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data;
                    this.table.paginateData = res.data;
                    this.table.total.amount = res.total;
                }
            });
        },
        delete: function () {
            ApiService.DELETE(ApiRoutes.BankWithdraw + '/' + this.id[0], (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
    },
    mounted() {
        this.list()
        this.fetchProject();
        this.fetchBank();
    },
    created() {
        this.breadCrumb.push(this.$route.name)
    }
}
</script>

<style scoped>

</style>
